import { render, staticRenderFns } from "./ReviewSlider.vue?vue&type=template&id=2b151783"
import script from "./ReviewSlider.vue?vue&type=script&lang=js"
export * from "./ReviewSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports